import React from "react";
import { Navigate } from "react-router-dom";

// Friendly permanent-link slugs are no longer an everyday sign-in surface.
// Existing server-side permanent links remain migration-compatible; stale
// client routes lead agents to the safe passwordless entry point.
const AgentPortalRedirect = () => <Navigate to="/agent/login" replace />;

export default AgentPortalRedirect;
